const containerStack = {
  width: '100%',
  padding: '0 2rem',
};

const contentStack = (theme) => ({
  padding: '3rem 0',
  gap: '3.375rem',
  alignSelf: 'stretch',
  borderRadius: '1.5rem',
  background: `linear-gradient(180deg, ${theme.palette.contrast.A700} 0%, #000 100%)`,
});

const titleContainer = {
  width: '100%',
  gap: '1rem',
  padding: { xs: '0 1rem', sm: '0' },
};

const titleTypography = {
  color: 'white',
  textAlign: 'center',
  fontSize: { xs: '2rem', sm: '2.5rem' },
};

const stepperContainer = {
  width: '100%',
  maxWidth: '60rem',
};

export {
  containerStack,
  contentStack,
  titleContainer,
  titleTypography,
  stepperContainer,
};
